import React, { useRef } from 'react'
import { Button, Modal, Row, Col, Space } from 'antd'
import type { FormInstance } from 'antd/es/form'
import { useTranslation } from 'react-i18next'
import { ConformityTableType } from './types'
import ConformityForm from './ConformityForm'
import LinkButtons from './LinkButtons'

interface IProps {
  conformity: ConformityTableType
  setConformity: (conformity: ConformityTableType | undefined) => void
}

const UpdateModal = (props: IProps) => {
  const { conformity, setConformity } = props
  const { t } = useTranslation()

  const formRef = useRef<FormInstance>()

  const handleCancel = () => {
    setConformity(undefined)
  }

  return (
    <Modal
      title={t('conformities:modal.title', {
        domiciliationId: conformity.domiciliationId,
      })}
      open={!!conformity}
      onCancel={handleCancel}
      footer={
        <Button onClick={() => formRef.current!.submit()}>
          {t('conformities:modal.validate-button')}
        </Button>
      }
      width={800}
    >
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <Row justify="space-between">
          <Col span={16}>
            <Row justify="space-between">
              <Col>{t('conformities:columns.legal-representative-name')}</Col>
              <Col>{`${conformity.firstname} ${conformity.lastname}`}</Col>
            </Row>
            <Row justify="space-between">
              <Col>{t('conformities:columns.society-name')}</Col>
              <Col>{conformity.societyName}</Col>
            </Row>
            <Row justify="space-between">
              <Col>{t('conformities:columns.society-brandname')}</Col>
              <Col>{conformity.societyBrandName}</Col>
            </Row>
            <Row justify="space-between">
              <Col>{t('conformities:columns.legal-status')}</Col>
              <Col>{conformity.legalStatus}</Col>
            </Row>
            <Row justify="space-between">
              <Col>{t('conformities:columns.address-domiciliation')}</Col>
              <Col>{conformity.fullAddress}</Col>
            </Row>
            <Row justify="space-between">
              <Col>{t('conformities:columns.society-type')}</Col>
              <Col>{conformity.societyType}</Col>
            </Row>
          </Col>
          <Col span={6}>
            <LinkButtons conformity={conformity} />
          </Col>
        </Row>
        <ConformityForm
          conformity={conformity}
          setConformity={setConformity}
          formRef={formRef}
        />
      </Space>
    </Modal>
  )
}

export default UpdateModal
